import React from "react";
import IconComponent from "../../components/Icon/IconComponent";
import { ICON_LABELS } from "../../utils/constants/UI/iconLabels";
import { AUTH_ASIDE_LOGO } from "../../utils/constants/assets";
import { BASE } from "../../utils/constants/colors";

const ASIDE_STATS = [
  {
    icon: ICON_LABELS.MANAGE_SEARCH,
    title: "AI ICP Scoring",
    description: "Pinpoint your best-fit buyers",
  },
  {
    icon: ICON_LABELS.CAMPAIGN,
    title: "3-Channel Sequences",
    description: "Email, calls & LinkedIn",
  },
  {
    icon: ICON_LABELS.TRENDING_UP,
    title: "Full Pipeline View",
    description: "From outreach to closed deal",
  },
];

const AuthAside = () => (
  <aside className="onb-auth-aside">
    <div className="onb-aside-logo-row">
      <img src={AUTH_ASIDE_LOGO} className="onb-aside-logo" alt="ReachIQ" />
    </div>
    <div className="onb-aside-text-block">
      <p className="onb-ahead">
        Qualified meetings,
        <br />
        not more leads.
      </p>
      <p className="onb-ahead-sub">
        ReachIQ is the outbound platform built for B2B sales teams. Identify
        high-fit prospects, run multi-channel sequences, and turn replies into revenue.
      </p>
    </div>
    <div className="onb-astats">
      {ASIDE_STATS.map((stat) => (
        <div className="onb-astat" key={stat.title}>
          <span className="onb-astat-icon">
            <IconComponent iconLabel={stat.icon} fontSize="20px" color={BASE.WHITE} />
          </span>
          <div className="onb-astat-text">
            <b>{stat.title}</b>
            <small>{stat.description}</small>
          </div>
        </div>
      ))}
    </div>
  </aside>
);

export default AuthAside;
